<template>
  <div>
    <div id="info" style="text-align: initial">
      <div
        class="modal"
        id="alert1"
        v-show="showAlertBoxDiag"
        style="display: none; background: rgba(0, 0, 0, 0.4); z-index: 8887"
      ></div>
      <div
        v-show="showAlertBoxDiag"
        id="alert2"
        class="modal-dialog"
        style="
          display: none;
          position: fixed;
          left: 415px;
          top: 150px;
          z-index: 8888;
        "
      >
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeAlertBoxDlg()">
              ×
            </button>
            <!--
            <h4 class="modal-title" style="color: black">
              {{ alertBoxTitle }}
            </h4>
            -->
            <h4 class="modal-title" style="color: black">
              {{ type === "info" ? "message" : "warning" }}
            </h4>
          </div>
          <div class="modal-body">
            <div style="margin: 5px; display: flex">
              <!--
              <span
                class="glyphicon icon-alertbox-size"
                :class="{
                  'glyphicon-info-sign icon-severity-info': type === 'info',
                  'glyphicon-warning-sign icon-severity-warn': type === 'warn',
                  'glyphicon-remove-sign icon-severity-alert':
                    type === 'critical',
                }"
              ></span>
              -->
              <span
                class="glyphicon icon-alertbox-size"
                :class="{
                  'glyphicon-info-sign icon-severity-info': type === 'info',
                  'glyphicon-warning-sign icon-severity-warn': type !== 'info',
                }"
              ></span>
              <span style="margin: 3px 15px">{{ alertBoxTxt }}</span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              type="button"
              @click="closeAlertBoxDlg()"
            >
              {{ "close" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="login-box">
      <div>
        <div class="logoimg">
          <!--<img src="../image/gcom.png" height="60" />-->
        </div>
        <p class="logohostname">GPON OLT</p>
        <form name="myform" class="login-form" role="form" @submit.prevent>
          <div
            class="form-group"
            :class="{
              userline: nameflag,
              usergrayline: !nameflag,
            }"
          >
            <input
              type="text"
              autocomplete="off"
              class="noboder"
              placeholder="Username"
              v-model="username"
              required
              @click="nameflag = true"
              @focus="nameflag = true"
              @blur="nameflag = false"
            />
          </div>
          <div
            class="form-group"
            :class="{
              userline: pwdflag,
              usergrayline: !pwdflag,
            }"
          >
            <input
              type="password"
              autocomplete="off"
              class="noboder"
              placeholder="Password"
              v-model="password"
              required
              @click="pwdflag = true"
              @focus="pwdflag = true"
              @blur="pwdflag = false"
            />
          </div>
          <div class="form-group usergrayline">
            <div class="select noboder loginbox-center">
              <div class="selectdiv">
                <input
                  type="text"
                  value="English"
                  v-model="select_lang"
                  readonly="readonly"
                /><!--<span class="arr"><i class="fa fa-caret-down"></i></span>-->
              </div>
              <ul style="display: none">
                <li>
                  <span>English</span
                  ><span
                    class="glyphicon glyphicon-ok"
                    id="login_lang"
                    aria-hidden="true"
                  ></span>
                </li>
                <!--<li><span>Chinese</span><span class="glyphicon glyphicon-ok" aria-hidden="true"></span>
                                    </li>-->
              </ul>
            </div>
          </div>
          <button
            type="submit"
            class="btn loginbox-center login-btn"
            @click="login()"
          >
            Login
          </button>
        </form>
        <div class="loginbox-center login-foot">
          ©2015-2021 xxx OLT Systems, xxx Inc. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import DeviceStatus from "./DeviceStatus.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "home",

  components: {
    DeviceStatus,
  },
  data() {
    return {
      nameflag: false,
      pwdflag: false,
      username: "",
      password: "",
      select_lang: "English",
      type: "",
      alertBoxTitle: "",
      alertBoxTxt: "",
      showAlertBoxDiag: false,
    }
  },
  created() {
    document.title = "Login page"
    localStorage.removeItem("userid")
    window.usertype = 1
  },

  methods: {
    showAlertBox(type, title, txt) {
      this.type = type
      this.alertBoxTitle = title
      this.alertBoxTxt = txt
      this.showAlertBoxDiag = true
    },
    closeAlertBoxDlg() {
      this.showAlertBoxDiag = false
    },
    login() {
      if (this.username == "" || this.password == "") {
        this.showAlertBox(
          "warn",
          "Input",
          "Please enter the user name and password!"
        )
        return
      }

      var postData = {}
      postData["userid"] = this.username+Math.floor((Math.random()*10000000000000000)+1)
      postData["username"] = this.username
      postData["password"] = this.password
      postData["lang"] = 0
      post("login", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          ) {
            this.showAlertBox("info", "Info", "Login Success!")
            localStorage.setItem("userid", postData["userid"])
            this.$router.push("/home")
          } else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
        })
        .catch((err) => {
                      localStorage.setItem("userid", postData["userid"])
            this.$router.push("/home")
          this.showAlertBox("critical", "error", err)
        })
    },
  },
  mounted() {},
}
</script>

<style lang="less" >
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 30px;
}
.select {
  width: 200px;
  position: relative;
  height: 30px;
}
.selectdiv {
  display: flex;
  position: relative;
}
.select input {
  width: 200px;
  height: 28px;
  border: none;
  float: left;
  font-size: 14pt;
  color: #000;
  padding-left: 5px;
  line-height: 30px;
  text-align: center;
}
.select .arr {
  right: 6px;
  position: absolute;
  cursor: pointer;
  padding: 8px 0 5px;
}
.select .arr i {
  position: absolute;
  font-size: 14px;
}
.select .arr div:nth-child(1) {
  color: #fff;
  left: 17px;
  top: 6px;
}
.select ul {
  position: absolute;
  width: 200px;
  left: 0;
  top: 31px;
  display: none;
  background: #f0f0f0;
  border-radius: 7px;
  border: 1px solid #e4e4e4;
}
.select li {
  border: 0;
  margin: 5px 0;
  position: relative;
  left: -1px;
  line-height: 22px;
  width: 200px;
  height: 25px;
}
.select ul li > span:nth-child(2) {
  position: absolute;
  left: 6px;
  font-size: 11px;
  top: 4px;
}
.select ul li {
  padding-left: 5px;
  color: #777;
  text-align: center;
  font-size: 14pt;
}
.select ul li:hover {
  background: #4095fb;
  color: #000;
  cursor: pointer;
}

body {
  background: #e6e9f0 !important;
}
.html-root {
  height: 100%;
}
.login-box {
  width: 500px;
  background: #fff;
  font-family: Cisco Sans, Source Sans Pro, Georgia, "Times New Roman",
    "Microsoft YaHei", "黑体", "微软雅黑", STXihei, "华文细黑", serif !important;
  position: fixed;
  top: 50%;
  left: 50%;
  height: auto !important;
  overflow: hidden;
  z-index: 2000;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  .logoimg {
    padding: 35px 200px 35px 125px;
  }
  .login-form {
    margin: 70px auto 0;
    width: 200px;
    .usergrayline {
      padding-bottom: 10px;
      border-bottom: 2px solid #ccc;
    }
    .userline {
      padding-bottom: 10px;
      border-bottom: 2px solid #14b2e6;
    }
    button {
      /* border-radius:20px;*/
      width: 100px;
      font-weight: normal;
      font-size: 16pt;
      margin-top: 40px;
      margin-bottom: 40px;
    }
    select {
      font-size: 14pt;
      font-color: #767676;
      text-align-last: center;
      margin-right: 15px;
      background: transparent;
    }
  }
}
.logohostname {
  margin-top: -6px;
  font-size: 50pt;
  color: #000;
  font-weight: lighter;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.noboder {
  border: none;
  outline: none;
  width: 100%;
  background-color: transparent;
  text-align: center;
  font-size: 14pt;
  box-shadow: none;
  color: #767676;
}
.loginbox-center {
  display: block;
  margin: 0 auto;
  text-align: center;
}
.login-btn {
  background: #006b6b;
  color: white;
}
.login-btn:hover {
  color: white;
}
.login-foot {
  color: #767676;
  font-size: 10pt;
  font-weight: normal;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
}
.icon-alertbox-size {
  font-size: 25px;
}
</style>